export default __webpack_public_path__ + "static/media/focus.6287f92c.jpeg";